import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { TokenService } from '../../token/token.service';
import { AuthService } from '../../services/auth/auth.service';

export interface TableData {
  revenueRange: string;
  feeExclVAT: number;
  feeInclVAT: number;
}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css'
})
export class DashboardComponent implements OnInit {

  dataSource: TableData[] = [
    {revenueRange: 'From 0 to 1', feeExclVAT: 180, feeInclVAT: 217.8},
    {revenueRange: 'From 1 to 5', feeExclVAT: 230, feeInclVAT: 278.3},
    {revenueRange: 'From 5 to 10', feeExclVAT: 350, feeInclVAT: 423.5},
    {revenueRange: 'from 10 upward', feeExclVAT: 540, feeInclVAT: 653.4},
    // Add more data as needed
  ];

  membershipOptions = {
    oneYear: {
      title: 'One Year Membership',
      tiers: [
        { revenueRange: 'From 0 to 1', description: 'Millions of € in Revenue', amount: '€180' },
        { revenueRange: 'From 1 to 5', description: 'Millions of € in Revenue', amount: '€230' },
        { revenueRange: 'From 5 to 10', description: 'Millions of € in Revenue', amount: '€350' },
        { revenueRange: 'From 10 upward', description: 'Millions of € in Revenue', amount: '€540' }
      ]
    },
    threeYear: {
      title: 'Three Year Membership',
      tiers: [
        { revenueRange: 'From 0 to 1', description: 'Millions of € in Revenue', amount: '€540' },
        { revenueRange: 'From 1 to 5', description: 'Millions of € in Revenue', amount: '€690' },
        { revenueRange: 'From 5 to 10', description: 'Millions of € in Revenue', amount: '€1050' },
        { revenueRange: 'From 10 upward', description: 'Millions of € in Revenue', amount: '€1620' }
      ]
    }
  };

  certificationEligiblityImages: any[] = [
    {id: '1', image: 'assets/images/carousel/Photo 1.webp', alt: 'Certification Eligibility Photo 1', title: 'Certification Eligibility Photo 1'},
    {id: '2', image: 'assets/images/carousel/Photo 2.webp', alt: 'Certification Eligibility Photo 2', title: 'Certification Eligibility Photo 2'},
    {id: '3', image: 'assets/images/carousel/Photo 3.webp', alt: 'Certification Eligibility Photo 3', title: 'Certification Eligibility Photo 3'},
    {id: '4', image: 'assets/images/carousel/Photo 4.webp', alt: 'Certification Eligibility Photo 4', title: 'Certification Eligibility Photo 4'},
    {id: '5', image: 'assets/images/carousel/Photo 5.webp', alt: 'Certification Eligibility Photo 5', title: 'Certification Eligibility Photo 5'},
    {id: '6', image: 'assets/images/carousel/Photo 6.webp', alt: 'Certification Eligibility Photo 6', title: 'Certification Eligibility Photo 6'},
    {id: '7', image: 'assets/images/carousel/Photo 7.webp', alt: 'Certification Eligibility Photo 7', title: 'Certification Eligibility Photo 7'}
  ];

  certificationEligiblityText: any[] = [
    {eligilibityText: 'The business is <strong>more than 50.1%</strong> owned, managed and controlled/operated by people from <strong>ethnic minority and non-Western background.</strong>'},
    {eligilibityText: 'The business is a <strong>for-profit enterprise.</strong>'},
    {eligilibityText: 'The business is located & registered in the <strong>Netherlands, Germany, France, Belgium, Ireland, Italy, or Spain.</strong>'},
    {eligilibityText: 'The relevant ethnic minority individuals considered to qualify as an EMB must be <strong>EU citizens</strong> or hold <strong>5 year-visa/resident permit.</strong>'},
    {eligilibityText: '<a href="https://esdp-org.eu/wp-content/uploads/Supporting-Documents-required-for-ESDP-Certification-2026-.pdf" target="_blank"><strong><u>Supporting documents required for ESDP Certification</u></strong></a> need to be submitted.'}
  ];

  definationArray: any[] = [
    {src: 'assets/images/Ethnic_Minority_Definition.png', alt: 'Ethnic Minority Definition', title: 'Ethnic Minority Definition', text: '"Ethnic Minority" Definition'},
    {src: 'assets/images/EMB_Definition.png', alt: 'Ethnic Minority Business Definition', title: 'Ethnic Minority Business Definition', text: '"Ethnic Minority Business" Definition'},
    {src: 'assets/images/Corporate_Members_Definition.png', alt: 'Corporate Members Definition', title: 'Corporate Members Definition', text: '"Corporate Members" Definition'},
  ];

  testimonials: any[] = [
    {id: '1', name: 'Axelle Ahanhanzo', titleCompany: 'Founder, LAUDACE', testimonial: '"ESDP has been instrumental in expanding LAUDACE\'s network and business opportunities. Through events and conferences, we have built strong relationships, generating hot leads that we are actively working to convert. The pitching session with Brian Ziskie, a procurement expert from Roche, helped refine our pitching strategy, turning insights into action. ESDP has also provided visibility beyond the Netherlands, allowing us to showcase LAUDACE internationally."', image: 'assets/images/testimonials-pics/Axelle Ahanhanzo - LAUDACE.jpg', alt: 'Axelle Ahanhanzo', title: 'Axelle Ahanhanzo'},
    {id: '2', name: 'Kemo Camara', titleCompany: 'Founder & CEO, Omek', testimonial: '"ESDP has played a key role in expanding Omek\'s network and visibility among its corporate partners. For example, our participation in all the ESDP events last year meant an opportunity to have multiple touchpoints to engage directly and have valuable conversations with procurement teams from corporate partners such as CBRE, Accenture, Amazon, Meta, Nike, and GSK, to name a few, all of whom are interested in working with diverse suppliers."', image: 'assets/images/testimonials-pics/Kemo Camara - Omek.webp', alt: 'Kemo Camara', title: 'Kemo Camara'},
    {id: '3', name: 'Rodney Frank', titleCompany: 'Principle CEO, Vision in Motion', testimonial: '"ESDP has been instrumental in my business growth, providing training, direct introductions to procurement leads, and support in crafting proposals, conducting needs analyses, and refining pitches. At events, the ESDP team has personally introduced me to key decision-makers, which led to two major projects. ESDP has also fostered a strong peer-to-peer support system among suppliers, creating opportunities for collaboration and shared learning"', image: 'assets/images/testimonials-pics/Rodney Frank - Vision in Motion.jpeg', alt: 'Rodney Frank', title: 'Rodney Frank'},
    {id: '4', name: 'Shirley Billot', titleCompany: 'Founder & CEO, KADALYS', testimonial: '"The experience of being involved with ESDP has opened incredible doors for us. It has allowed me to connect with international entrepreneurs, enriching my network and our strategic collaborations. One of the highlights has been meeting other inspiring business leaders sharing the same commitment to diversity, sustainability, and innovation. The opportunity to exchange ideas and learn from others has been invaluable."', image: 'assets/images/testimonials-pics/Shirley Billot - KADALYS.webp', alt: 'Shirley Billot', title: 'Shirley Billot'},
    {id: '5', name: 'Surja Bose', titleCompany: 'Founder & CEO, Bosenet Systemhaus', testimonial: '"Being part of ESDP has provided us with valuable opportunities in multiple ways. We were able to connect with several large corporations like EY, Enterprise, Amazon, IBM, and Booking Holdings, which would not have been possible without this platform. This had further led to specific one-to-one meetings with some corporates, where we were able to introduce ourselves in more detail."', image: 'assets/images/testimonials-pics/Surja Bose - Bosenet.jpg', alt: 'Surja Bose', title: 'Surja Bose'},
    {id: '6', name: 'Vivian Acquah CDE®', titleCompany: 'Founder, Amplify DEI', testimonial: '"ESDP has been a transformational partner in my professional growth and business success. From the very beginning, being a part of ESDP has clarified so many important aspects of engaging with large organizations—something that once seemed intimidating as a small business owner. Gaining the ESDP Certification was a game-changer for me. It was not just a piece of paper; it was my ticket to opportunities I might never have had otherwise."', image: 'assets/images/testimonials-pics/Vivian Acquah CDE® - Amplify DEI.jpg', alt: 'Vivian Acquah CDE®', title: 'Vivian Acquah CDE®'},
  ]

  displayedColumns: string[] = ['revenueRange', 'feeExclVAT'];

  certificationEligilibityOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 900,
    navText: [ "<i class='material-icons'>chevron_left</i>",
      "<i class='material-icons'>chevron_right</i>"],
    nav: true,
    items: 1,
    autoplay: true,
    autoplayTimeout: 5000,
    smartSpeed: 2000
  };

  testimonialsOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: [ "<img src='assets/icons/esdp-logo.png' alt='Left Arrow' class='w-[6%] rotate-180'>",
      "<img src='assets/icons/esdp-logo.png' alt='Right Arrow' class='w-[6%]'>"],
    nav: true,
    responsive: {
      0: {
        items: 3
      }
    },
  }


  constructor(private router: Router, private tokenService: TokenService, private authService: AuthService) {}

  ngOnInit(): void {
    this.tokenService.updateToken(null);
    this.logout();
  }

  async logout() {
    try {
    const response = await this.authService.logout();
    if (response) {
      if (response.success) {
        sessionStorage.clear();
        localStorage.clear();
      }
    }
  } catch (error) {
    console.error('Unexpected error:', error);
    // Handle unexpected errors globally (optional)
  }
  }

  goToCreateAccount() {
    this.router.navigate(['/register']);
  }

  goToLogin() {
    this.router.navigate(['/login']);
  }
}